import { render, staticRenderFns } from "./CorrectStat.vue?vue&type=template&id=0ce2e365&scoped=true&"
import script from "./CorrectStat.vue?vue&type=script&lang=js&"
export * from "./CorrectStat.vue?vue&type=script&lang=js&"
import style0 from "./CorrectStat.vue?vue&type=style&index=0&id=0ce2e365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2e365",
  null
  
)

export default component.exports